import { z } from 'zod';
import { BooleanOptional } from './schemaTypes';
export const CheckinSchema = z.object({
    CheckinConditions: z.array(z.string()).optional(),
    showConsents: BooleanOptional
});
